import styled from "@emotion/styled";

export default function Image4() {
  return <RootWrapperImage4 />;
}

const RootWrapperImage4 = styled.div`
  width: 2711px;
  height: 233px;
  background: url(https://s3-alpha-sig.figma.com/img/3729/1a28/7673b7e29c3ed798802269960cc11cad?Expires=1748822400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=aWll8ERqia8z9iqM4HeeFyuGXgWnQuqPozbHIrbsh4IT0pDgBggG~s29qdXGhudxkEvlCvLkdRN-o-psXyTmiuW-zTbhYPwlraMzXk2-UGJc0wUYepVFdEbNmch7V716oZaSizikCCe0s~Y4LjoesggqGgaVgimDPpm4baNa-UHQZf6OmJqMDWZACdVRAVBoviCaPKUuF~KQm86WXAc3XvrSE-geZ0e5Wjl8DeIHc2gY~c5C1GBe5E5qyhB-WtoanYExDqg~JsSZNoaFxRQ0xydP6fGafjpqFt7wZMwtAYhTqEinb0QBCFSgSiQ9JnWfmxW5e5vV2eXxZKhZ29iRJQ__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;
